export default __webpack_public_path__ + "static/media/avatarD3.0b353dca.png";